<template>
  <div>
    <div class="title">开通的服务城市？</div>
    <div class="content-info">
      <p
        class="txt1"
        id="citysHelp"
      >目前全国开通城市，包括为北京、天津、上海、杭州、温州、济南、青岛、郑州、合肥、武汉、广州、深圳、东莞、南京、常州、苏州、无锡、成都、重庆、西安、长沙等城市。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
